// app版本号
export const APPVERSION = navigator.userAgent.toLowerCase().split(' ')[0].split('juno/')[1]
    ? navigator.userAgent.toLowerCase().split(' ')[0].split('juno/')[1]
    : '';

// 是否在juno app内打开
export let ISJUNOAPP =
    location.hostname == 'localhost'
        ? true
        : window.navigator.userAgent.toLowerCase().match(/juno/i) == 'juno';

// 获取url参数，以json格式返回所有参数
export function getQueryString() {
    var reg = new RegExp('(^|&)=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}

//获取指定url参数
export function getUrlParam(name, origin = null) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    let search = window.location.search;
    let r = null;
    if (origin == null) {
        r = search.substr(1).match(reg);
    } else {
        r = origin.substr(1).match(reg);
    }
    if (r != null) return decodeURIComponent(r[2]);
    return null;
}

//获取hash路由模式的url参数
export function getHashSearchParam(key) {
    const url = location.href;
    // 获取 hash 值，不包含 '#' 号
    const hash = url.substring(url.indexOf('#') + 1);
    // 查找 '?' 号所在的索引
    const searchIndex = hash.indexOf('?');
    // '?' 号后面接的是索引参数，如果找到则+1，去除'?' 号
    const search = searchIndex !== -1 ? hash.substring(searchIndex + 1) : '';
    // 把搜索参数字符串提过URLSearchParams转成对象形式
    const usp = new URLSearchParams(search);
    // 通过URLSearchParams自带的get方法，查询键所对应的值
    return usp.get(key);
}

// 判断浏览器环境是否是 微信
export function isWexin() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
    } else {
        return false;
    }
}

// 设置webview标题
export function setTitle(title) {
    document.title = title;
    try {
        clientSetTitle.postMessage(title);
    } catch (error) {}
}
// webview返回逻辑
window.leftBack = () => {
    if (!!window.history.state?.back) {
        window.history.back();
    } else {
        try {
            webBack.postMessage('');
        } catch (error) {}
    }
};

/**
 * app版本大小比对
 * 使用方式： compareVersion(myvs,tovs) > -1  即 myvs版本号大于等于 tovs 版本号
 */
export function compareVersion(v1, v2) {
    v1 = v1.split('.');
    v2 = v2.split('.');
    const len = Math.max(v1.length, v2.length);

    // 调整两个版本号位数相同
    while (v1.length < len) {
        v1.push('0');
    }
    while (v2.length < len) {
        v2.push('0');
    }

    // 循环判断每位数的大小
    for (let i = 0; i < len; i++) {
        const num1 = parseInt(v1[i]);
        const num2 = parseInt(v2[i]);

        if (num1 > num2) {
            return 1;
        } else if (num1 < num2) {
            return -1;
        }
    }

    return 0;
}
//简单的防抖函数
export function debounce(func, wait, immediate) {
    //定时器变量
    var timeout;
    return function () {
        //每次触发scrolle，先清除定时器
        clearTimeout(timeout);
        //指定多少秒后触发事件操作handler
        timeout = setTimeout(func, wait);
    };
}

//节流函数
export function throttle(fun, delay) {
    let last, deferTimer;
    return function (args) {
        let that = this;
        let _args = arguments;
        let now = +new Date();
        if (last && now < last + delay) {
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fun.apply(that, _args);
            }, delay);
        } else {
            last = now;
            fun.apply(that, _args);
        }
    };
}
//复制文本
export function copyText(text,func) {
    var element = createElement(text);
    element.select();
    element.setSelectionRange(0, element.value.length);
    document.execCommand('copy');
    element.remove();
    return func
}

//创建临时的输入框元素
function createElement(text) {
    var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
    var element = document.createElement('textarea');
    // 防止在ios中产生缩放效果
    element.style.fontSize = '12pt';
    // 重置盒模型
    element.style.border = '0';
    element.style.padding = '0';
    element.style.margin = '0';
    // 将元素移到屏幕外
    element.style.position = 'absolute';
    element.style[isRTL ? 'right' : 'left'] = '-9999px';
    // 移动元素到页面底部
    let yPosition = window.pageYOffset || document.documentElement.scrollTop;
    element.style.top = `${yPosition}px`;
    //设置元素只读
    element.setAttribute('readonly', '');
    element.value = text;
    document.body.appendChild(element);
    return element;
}
